import { render, staticRenderFns } from "./PiHoleTraffic.vue?vue&type=template&id=30b17579&"
import script from "./PiHoleTraffic.vue?vue&type=script&lang=js&"
export * from "./PiHoleTraffic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports